/* eslint-disable no-nested-ternary */
import React, { useCallback, useState, useMemo } from 'react'

import clsx from 'clsx'
import Switch from 'components/generic/formInputs/Switch/Switch'
import s from './CollectionsList.module.css'

function CollectionsList({ collections, isLoading, unitId, fetchCollections, onChangeSearchValue, searchValue }) {
  const [inProgress, setInProgress] = useState(false)
  const [onlyArchived, setOnlyArchived] = useState(false)

  const filteredCollections = useMemo(() => {
    return collections?.filter((collection) => collection.archived === onlyArchived)
  }, [collections, onlyArchived])

  const handleAddToCollection = useCallback(
    async (collectionId) => {
      try {
        setInProgress(true)
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${collectionId}/add_listing`, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'PUT',
          body: JSON.stringify({ listing_id: unitId }),
        })

        const data = await response.json()
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        fetchCollections()
        setInProgress(false)
      }
    },
    [unitId]
  )

  const handleRemoveFromCollection = useCallback(
    async (collectionId) => {
      try {
        setInProgress(true)
        const apiToken = localStorage.getItem('apiToken')

        const response = await fetch(`/api/v3/listing_collections/${collectionId}/remove_listing`, {
          headers: {
            'API_TOKEN': apiToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'DELETE',
          body: JSON.stringify({ listing_id: unitId }),
        })

        const data = await response.json()
        console.log(data)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      } finally {
        fetchCollections()
        setInProgress(false)
      }
    },
    [unitId]
  )

  return (
    <div className={s.root}>
      <div className={s.title}>
        Existing collections{' '}
        <Switch
          value={onlyArchived}
          onChange={setOnlyArchived}
          beforeText={
            <span className={clsx(s.activeCollections, !onlyArchived && s.activeCollectionState)}>Active</span>
          }
          afterText={
            <span className={clsx(s.archivedCollections, onlyArchived && s.activeCollectionState)}>Archived</span>
          }
        />
      </div>

      <div className={s.searchField}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path
            d="M14.7 15.75L9.975 11.025C9.6 11.325 9.16875 11.5625 8.68125 11.7375C8.19375 11.9125 7.675 12 7.125 12C5.7625 12 4.6095 11.528 3.666 10.584C2.7225 9.64 2.2505 8.487 2.25 7.125C2.2495 5.763 2.7215 4.61 3.666 3.666C4.6105 2.722 5.7635 2.25 7.125 2.25C8.4865 2.25 9.63975 2.722 10.5848 3.666C11.5298 4.61 12.0015 5.763 12 7.125C12 7.675 11.9125 8.19375 11.7375 8.68125C11.5625 9.16875 11.325 9.6 11.025 9.975L15.75 14.7L14.7 15.75ZM7.125 10.5C8.0625 10.5 8.8595 10.172 9.516 9.516C10.1725 8.86 10.5005 8.063 10.5 7.125C10.4995 6.187 10.1715 5.39025 9.516 4.73475C8.8605 4.07925 8.0635 3.751 7.125 3.75C6.1865 3.749 5.38975 4.07725 4.73475 4.73475C4.07975 5.39225 3.7515 6.189 3.75 7.125C3.7485 8.061 4.07675 8.858 4.73475 9.516C5.39275 10.174 6.1895 10.502 7.125 10.5Z"
            fill="#A7A7A7"
          />
        </svg>

        <input
          className={s.searchInput}
          type="text"
          id="search"
          placeholder="Type Collection’s Name"
          value={searchValue}
          onChange={(e) => {
            const { value } = e.target
            onChangeSearchValue(value)
          }}
        />
      </div>

      {isLoading ? (
        <div className={s.inform}>Loading...</div>
      ) : filteredCollections.length > 0 ? (
        <div className={s.collections}>
          {filteredCollections?.map((collection) => {
            const isInCollection = collection?.listing_ids?.includes(unitId)
            return (
              <div key={collection.id} className={clsx(s.collection, isInCollection && s.active)}>
                <div className={s.collectionImage}>
                  <img className={s.collectionImageElem} src={collection.cover_photo_url} alt={collection.name} />
                </div>
                <div className={s.collectionName}>{collection.name}</div>

                <div className={s.controls}>
                  {isInCollection ? (
                    <button
                      disabled={inProgress}
                      type="button"
                      className={s.button}
                      onClick={() => handleRemoveFromCollection(collection.id)}
                    >
                      Remove
                    </button>
                  ) : (
                    <button
                      disabled={inProgress}
                      type="button"
                      className={s.button}
                      onClick={() => handleAddToCollection(collection.id)}
                    >
                      Add
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      ) : (
        <div className={s.inform}>Your Collections are empty</div>
      )}
    </div>
  )
}

export default CollectionsList
